/**
 * Span attribute the head sampler routes on. Set at span creation (sampler decisions are made in
 * `startSpan`); setting it after creation has no sampling effect. Must stay in sync with the
 * duplicate constant in `@storyboard/web-client`'s `web-client/telemetry.ts`.
 */
export const TELEMETRY_CATEGORY_ATTRIBUTE = "telemetry.category";

/**
 * Sampling categories — the closed taxonomy for everything web ships to Honeycomb. Each maps to a
 * per-session sample rate (LaunchDarkly `telemetrySampleRates`, see `DEFAULT_SAMPLE_RATES`).
 * Spans without a category are treated as `diagnostic`, which ships nothing by default.
 */
export type TelemetryCategory = "api" | "perceived" | "vitals" | "perf" | "reliability" | "diagnostic";
